import * as React from "react";
const arrowUpClass = "rj-prepacks-odds-update-arrow--up";
const arrowDownClass = "rj-prepacks-odds-update-arrow--down";
//Todo extract to lib - https://jira.dkcorpit.com/browse/SB-24657
export class OddsUpdateIndicator extends React.Component {
    constructor() {
        super(...arguments);
        this.arrowRef = React.createRef();
        this.animateIncrease = () => {
            if (this.arrowRef.current) {
                this.arrowRef.current.classList.add(arrowUpClass);
            }
        };
        this.animateDecrease = () => {
            if (this.arrowRef.current) {
                this.arrowRef.current.classList.add(arrowDownClass);
            }
        };
        this.handleAnimationEnd = () => {
            if (this.arrowRef.current) {
                this.arrowRef.current.classList.remove(arrowUpClass, arrowDownClass);
            }
        };
    }
    shouldComponentUpdate(nextProps) {
        if (nextProps.trueOdds > this.props.trueOdds) {
            this.props.onOddsUpdate();
            this.animateIncrease();
        }
        else if (nextProps.trueOdds < this.props.trueOdds) {
            this.props.onOddsUpdate();
            this.animateDecrease();
        }
        return false;
    }
    render() {
        return React.createElement("span", { "data-testid": "arrow-odds-update", ref: this.arrowRef, onAnimationEnd: this.handleAnimationEnd, className: "rj-prepacks-odds-update-arrow" });
    }
}
//# sourceMappingURL=OddsUpdateIndicator.js.map